<div class="absolute inset-0">
  <div class="relative container m-auto flex flex-col h-full justify-between ">

    <div class="my-6">
      <a routerLink="/rooms">Rooms</a> / <span *ngIf="room">{{room.name}}</span>
    </div>



    <div class="grow overflow-y-auto" *ngIf="room">

      <app-points-breakdown [roomId]="room.id"></app-points-breakdown>

    </div>

  </div>
  <app-footer></app-footer>
</div>
